import './booking-management.css';
import { createRoot } from '@wordpress/element';
import { QueryClientProvider } from '@tanstack/react-query';
import { fieldQueryClientFactory } from '../fields/lib/queryClient';
import BookingManagement from './components/BookingManagement';

const container = document.getElementById('gpb-booking-management');
const queryClient = fieldQueryClientFactory();

if (container) {
	const root = createRoot(container);
	root.render(
		<QueryClientProvider client={queryClient}>
			<BookingManagement />
		</QueryClientProvider>
	);
} else {
	// eslint-disable-next-line no-console
	console.error('GP Bookings: Container #gpb-booking-management not found.');
}
